<template>
	<header id='header'>
		<div class="dis-flex" style="min-width: 1188px;margin: 0 auto;">
			<div class="qy-logo cursorPointer" @click="handleToPage(1)" style="font-size: 26px;color: #ffffff;">
				<!-- <img  @dragstart.prevent  src="../assets/logo.png" alt=""> -->
				 太原巴卡巴科技
			</div>
			<div class="mytabbar dis-flex">
				<ul class="mytabbar-item" v-for="item in tabList" :key="item.type">
					<li v-if="item.type > 0 && item.type < 5" @click="handleToPage(item.type)">
						<span v-if="item.type != 5" :style="{ fontWeight: item.type == bg ? 'bold' : 'normal' ,color: item.type == bg ? '#fff' : '#eee' }">{{ item.name }}</span>
					</li>
					<li v-else-if="item.type == 5 && isShowSearch" class="ope-search" @mouseleave="searchList = []">
						<!-- <div class="ope-seabg"></div>
						<input type="text" placeholder="搜索作品名称" v-model="searchval"  @keyup="e => { getSeachUp(e) }">
						<div class="ope-btn flex-center" @click="getSeachList"  >
							<img  @dragstart.prevent  src="../assets/icon_sousuo.png" alt="">
						</div> -->
					</li>
					<li v-else-if="item.type == 5 && !isShowSearch" style="width:240px"></li>
					<li v-else @click="handleToPage(item.type)">
						<span>{{ item.name }}</span>
					</li>
				</ul>
			</div>
			<div class="ownweCenter flex-center" @mouseover="changeHover(true)" @mouseout="changeHover(false)">
				<img  @dragstart.prevent  src="../assets/touxiang.png" alt="点击登录" @click="handleToPage(24)">
				<div  v-if="props.loginstatus" class="hoverTab-box">
					<div class="hoverTab" v-show="isShowTab">
						<div class="hoverTab-tit">Hi，尊敬的用户<br/><span style="margin-top:5px">您好！</span></div>
						<div class="hoverTab-tab" v-for="(item,index) in hoverList" :key="index.type" @click="handleToPage(item.type)">
							<span v-if="item.type != 99">{{item.name}}</span>
							<span v-if="item.type == 99 && shuaxin">{{getUserInfo().autoSub == 1 ? '关闭自动订阅' : '开启自动订阅'}}</span>
						</div>
						<div class="hoverTab-btn" @click="handleLoginOut">退出</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>
<script setup>
import MainSwiper from '../components/mainSwiper.vue'
import { getCurrentInstance,ref, reactive, watch, defineEmits, toRefs, onMounted, toRaw } from "vue"
import Cookies from 'js-cookie'
import { useInfoApi, loginOutApi, switchAutoSub } from '@/utils/api'
import { navTo, removeToken , getUserInfo, removeUserInfo, refreshUserInfo} from '../utils/utils'
import { useRouter , onBeforeRouteUpdate } from 'vue-router'
const router = useRouter()
router.beforeEach((to, from, next) => {
    next()
	if(to.path == '/home'){
		bg.value = 1
	}else if(to.path == '/rankList'){
		bg.value = 2
	}else if(to.path == '/marvelExhibition'){
		bg.value = 3
	}else if(to.path == '/contribute'){
		bg.value = 4
	}else{
		bg.value = 0
	}
	if(to.path == '/searchPage'){
		isShowSearch.value = false
	}else{
		isShowSearch.value = true
	}
})
let tabList = ref([
	{ type: 1, name: '首页' },
	// { type: 2, name: '排行榜' },
	{ type: 3, name: '漫展' },
	{ type: 4, name: '投稿' },
	// { type: 5, name: '搜索' },
	// { type: 22, name: '观看历史' },
	// { type: 23, name: '收藏记录' },
	{ type: 24, name: '超值特惠' },
])
let bg = ref(1)
let hoverList = ref([
	// { type: 22, name: '观看历史' },
	// { type: 23, name: '收藏记录' },
	// { type: 24, name: '充值中心' },
	{ type: 99, name: '自动订阅' },
	{ type: 0, name: '用户协议' },
])
let isShowTab = ref(false)
let searchval = ref('')
let isShowSearch = ref(true)
let shuaxin = ref(true)


let historyList = ref([])
let searchList = ref([])
const emit = defineEmits(['refreshLogin'])
const props = defineProps({
    loginstatus:Boolean
})
onMounted(() => {
})
const changeHover = (val) => {
	isShowTab.value = val
}
const handleClose = () => {
	emit('refreshLogin')
}
const handleLoginOut=()=>{
	loginOutApi().then(res=>{
		// removeToken()
		removeUserInfo()
		emit('refreshLogin')
		navTo('/login')
		localStorage.setItem('currPath','/home')
	})
}
// watch(() => {
// 	let pat = router.currentRoute.value.path
// 	if (pat == '/detail') {
// 		bg.value = 1
// 	} else if (pat == '/user') {
// 		bg.value = 2
// 	} else if (pat == '/home') {
// 		bg.value = 0
// 	}
// })

let getSeachList = () => {
	let path='/searchPage'
	let query={searchval:searchval.value}
		navTo(path, query)
	setTimeout(()=>{
		searchval.value = ''
	},1000)
}
let getSeachUp=(event=>{
	if (event.keyCode === 13) {
		let path='/searchPage'
	  	let query={searchval:searchval.value}
		navTo(path, query)
  	}
})

/** type: 1 首页 2 分类 3 漫展 4 投稿 22 观看历史 23 收藏记录 24 超值特惠  */
let handleToPage = (type) => {
	if (type == 99){
		shuaxin.value = false
		switchAutoSub().then(res=>{
			if(res.code == 200){
				refreshUserInfo()
				setTimeout(()=>{
					shuaxin.value = true
				},100)
			}
		})
		return
	}
	let path = '/'
	let query=''
	bg.value = type
	if (type == 1) {
		path = '/home'
		let str = `${path}`
    	localStorage.setItem('currPath',str)
	} else if (type == 2) {
		path = '/rankList'
	} else if (type == 3) {
		path = '/marvelExhibition'
	} else if (type == 4) {
		path = '/contribute'
	} else if (type == 22 || type == 23 || type == 24) { 
		path = '/personal/personalComponents/personalCenter'
		query={id: type}
		let str = `${path}?id=${type}`
    	localStorage.setItem('currPath',str)
	} else if (type == 0) { //超值特惠
		path = '/personal/personalComponents/userAgreement'
		query={id: type,miniID:5,open:true}
		let str = `${path}?id=${type}&miniID=5&open=true`
    	localStorage.setItem('currPath',str)
	}
	navTo(path,query)
}
</script>

<style lang="scss" scoped>
#header {
	background: #363347;
	z-index: 99;
	width: 100%;
	height: 88px;
	box-sizing: border-box;
	position: fixed;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.qy-logo {
		width: 186px;
		height: 48px;
		img {
			width: 100%;
			height: 100%;
		}
	}

	.mytabbar {
		flex: 1;
		align-items: center;
		// justify-content: space-between;
		padding: 0 60px 0 25px;
		margin-left: 50px;
		&-item {
			cursor: pointer;
			margin-right: 40px;
			span {
				color: #fff;
				font-size: 18px;
			}
		}
	}

	.ownweCenter {
		width: 48px;
		height: 48px;
		position: relative;
		img{
			width: 100%;
			height: 100%;
			cursor: pointer;
			border-radius: 50%;
		}
		.hoverTab-box{
			position: absolute;
			top: 48px;
			left: -39px;
			padding-top: 5px;
			.hoverTab{
				display: flex;
				flex-direction: column;
				width: 133px;
				background: #FFFFFF;
				box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.2);
				border-radius: 10px;
				overflow: hidden;
				&-tit{
					padding: 15px 12px 6px;
					font-size: 12px;
					color: #333333;
					line-height: 17px;
				}
				&-tab{
					padding: 8px 0;
					background-color: #FFFFFF;
					font-size: 14px;
					color: #333333;
					line-height: 20px;
					display: flex;
    				justify-content: center;
					cursor: pointer;
				}
				&-tab:hover{
					color: #CB2945;
					background-color: rgba(203, 41, 69, 0.06);
				}
				&-btn{
					margin-top: 10px;
					border-top: 2px solid #ECECEC;
					font-size: 14px;
					color: #999999;
					line-height: 20px;
					text-align: center;
					padding: 15px 0;
					cursor: pointer;
				}
				&-btn:hover{
					background-color: #ececec50;
				}
			}
		}
	}

}

.quesheng {
	height: 120px;
	line-height: 120px;
	text-align: center;
	font-size: 24px;
}

.ope-search {
	cursor: pointer;
	position: relative;
	width: 240px;
	height: 36px;
	display: flex;
	justify-content: space-between;
	margin: 0 30px;
	align-items: center;

	.ope-seabg {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #fff;
		border-radius: 21px;
	}

	input {
		flex: 1;
		color: #666666;
		padding: 0 16px;
		background: transparent;
		outline: none;
		border: none;
		z-index: 9;
	}

	input::-webkit-input-placeholder {
		color: #666666;
		font-size: 14px;
	}

	.sea-wra {
		display: none;
		position: absolute;
		top: 54px;
		padding-top: 13px;
		left: 14px;
		width: 330px;

		.sea-list {
			background: #363347;
			max-height: 600px;
			overflow-y: scroll;
		}

		.sea-list::-webkit-scrollbar-track {
			background-color: #363347;
		}

		.sea-list::-webkit-scrollbar {
			width: 3px;
			background-color: rgba(255, 255, 255, 0.3) 50%;
		}

		.sea-list::-webkit-scrollbar-thumb {
			background-color: #FF2A2A;
			border-radius: 3px;
		}
	}

	&:hover {
		.sea-wra {
			display: block;
		}
	}

	.ope-btn {
		width: 120px;
		height: 54px;
		opacity: 1;
		z-index: 9;

		img {
			width: 20px;
			height: 20px;
		}
	}
}
</style>
